<script lang="ts">
  import AwsSystemCard from "./awsSystemCard.svelte";
  import AceLinkCard from "./aceLinkCard.svelte";

  export let totalOpportunities: number;
  export let fullySynced: number;
  export let acelinkTotal: number;
  export let errors: number;
  export let lastSyncTime: string;
</script>

<div
  class="min-w-0 rounded-xl border border-white/10 bg-[linear-gradient(135deg,rgba(255,255,255,0.045)_0%,rgba(255,255,255,0.02)_100%)] p-4 shadow-[inset_0_1px_0_rgba(255,255,255,0.035)] sm:p-5"
>
  <h3
    class="text-[1.125rem] font-bold text-white mb-4 uppercase tracking-[0.5px]"
  >
    System Sync Overview
  </h3>
  <div class="systems-overview-grid">
    <!-- AWS Card -->
    <div class="min-w-0">
      <AwsSystemCard
        {totalOpportunities}
        {fullySynced}
        {errors}
        {lastSyncTime}
      />
    </div>

    <!-- Sync Arrows -->
    <div class="flex items-center justify-center px-1">
      <div class="text-3xl text-white/50 font-normal xl:text-4xl">
        <span class="xl:hidden">⇅</span>
        <span class="hidden xl:inline">⇄</span>
      </div>
    </div>

    <!-- AceLink Card -->
    <div class="min-w-0">
      <AceLinkCard
        totalOpportunities={acelinkTotal}
        {fullySynced}
        {lastSyncTime}
      />
    </div>
  </div>
</div>

<style>
  .systems-overview-grid {
    display: grid;
    align-items: stretch;
    gap: 1rem;
    width: 100%;
  }

  @media (min-width: 1280px) {
    .systems-overview-grid {
      grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    }
  }
</style>
